"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOptionalDependencies = exports.useDependencies = void 0;
const react_1 = require("react");
const common_1 = require("./common");
function useDependenciesInternal(tokens, optional) {
    const ref = (0, react_1.useRef)(null);
    const container = (0, react_1.useContext)(common_1.ContainerContext);
    if (!ref.current) {
        ref.current = tokens.map(s => {
            if (optional) {
                if (container.isBound(s)) {
                    return container.get(s);
                }
                return undefined;
            }
            return container.get(s);
        });
    }
    return ref.current;
}
function useDependencies(...tokens) {
    return useDependenciesInternal(tokens, false);
}
exports.useDependencies = useDependencies;
function useOptionalDependencies(...tokens) {
    return useDependenciesInternal(tokens, true);
}
exports.useOptionalDependencies = useOptionalDependencies;
//# sourceMappingURL=use-dependencies.js.map